export default "__VITE_ASSET__8gj_olXf__"